import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assests/logo/ihfc_logo.png";
import signup from "../../../assests/logo/signup1C.png";
import { all_routes } from "../../router/all_routes";
import { toast } from "react-toastify";
import webserviceUrl from "../../../API/webserviceUrl";
import axios from "axios";
const image1 = "/images/loginImages/image1.webp";
const image2 = "/images/loginImages/image2.webp";
const image3 = "/images/loginImages/image3.webp";
const image4 = "/images/loginImages/image4.webp";
const image5 = "/images/loginImages/image5.webp";
const image6 = "/images/loginImages/image6.webp";
const image7 = "/images/loginImages/image7.webp";
const image8 = "/images/loginImages/image8.webp";
const image9 = "/images/loginImages/image9.webp";
const image10 = "/images/loginImages/image10.webp";
const image11 = "/images/loginImages/image11.jpeg";
const image12 = "/images/loginImages/image12.webp";
const image13 = "/images/loginImages/image13.webp";
const image14 = "/images/loginImages/image14.webp";
const image15 = "/images/loginImages/image15.webp";
const image16 = "/images/loginImages/image16.webp";
const image17 = "/images/loginImages/image17.jpeg";
const image18 = "/images/loginImages/image18.jpeg";
const image19 = "/images/loginImages/image19.jpeg";
const image20 = "/images/loginImages/image20.jpeg";
const image21 = "/images/loginImages/image21.jpeg";
const image22 = "/images/loginImages/image22.jpeg";
const image23 = "/images/loginImages/image23.webp";
const CELL_SIZE_DESKTOP = 120;
const CELL_SIZE_MOBILE = 70;
const MOBILE_BREAKPOINT = 480;

let arrayOfImages = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
];

type PasswordField = "password";

type loginData = {
  email: string;
  password: string;
  program_code: string;
};

const getSpanType = (idx: any) => idx % 5;

const calcGridDims = () => {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const cellSize = isMobile ? CELL_SIZE_MOBILE : CELL_SIZE_DESKTOP;

  // +2 buffer so rounding never leaves a gap at the edges
  const cols = Math.ceil(window.innerWidth / cellSize) + 2;
  const rows = Math.ceil(window.innerHeight / cellSize) + 2;

  return { cols, rows, cellCount: cols * rows };
};

const Login = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState<loginData>({
    email: "",
    password: "",
    program_code: "",
  });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });

  const [programCodes, setprogramCodes] = useState([]);

  // Program dropdown state
  const [programOpen, setProgramOpen] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState<any>();
  // const [loading, setLoading] = useState(false);
  const programRef = useRef<HTMLDivElement>(null);

  const [programData, setprogramData] = useState([]);
  const [loading, setloading] = useState(false);
  const [schoolCode, setschoolCode] = useState("");

  const getCohortData = async () => {
    try {
      setloading(true);
      let res = await axios.get(webserviceUrl.all_programs, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });
      console.log(res?.data?.data);
      if (res?.data?.success) {
        setProgramOpen(true);
        setloading(false);
        setprogramCodes(res?.data?.data);
        // PROGRAMS = res?.data;
      }
    } catch (e) {
      setloading(false);
      console.log(e, "error");
    }
  };

  const [gridDims, setGridDims] = useState(() =>
    typeof window !== "undefined"
      ? calcGridDims()
      : { cols: 10, rows: 10, cellCount: 100 },
  );

  // Recalculate the grid to always fully cover the viewport on resize
  useEffect(() => {
    const handleResize = () => {
      setGridDims(calcGridDims());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close the program dropdown when clicking outside it
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        programRef.current &&
        !programRef.current.contains(e.target as Node)
      ) {
        setProgramOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Build extra tiles (over-provision a bit since spanning tiles eat more than one cell)
  const tiles = useMemo(() => {
    const overProvisionedCount = Math.ceil(gridDims.cellCount * 1.6);
    return Array.from({ length: overProvisionedCount }).map((_, idx) => ({
      src: arrayOfImages[idx % arrayOfImages.length],
      span: getSpanType(idx),
    }));
  }, [gridDims]);

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const getInputData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const { email, password, program_code } = loginData;
    try {
      setIsSubmitting(true);
      const response = await axios.post(
        webserviceUrl.login,
        {
          email,
          password,
          program_code,
        },
        {
          validateStatus: () => true, // Accept all status codes
        },
      );

      // console("✅ Login Success:", response.data);
      if (response.data.success) {
        toast.success("Login successful");
        localStorage.setItem("login", "true");
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("school_code", response?.data?.program_code);
        localStorage.setItem("employee_id", response?.data?.data?.employee_id);
        localStorage.setItem("userData", JSON.stringify(response?.data?.data));
        // window.location.href = "/getBatches/lesson_plan";
        setTimeout(() => (window.location.href = "/"), 300);
      } else {
        toast.error(response.data.message || "Invalid credentials");
      }
    } catch (error: any) {
      console.error("Login error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setTimeout(() => setIsSubmitting(false), 500);
    }
  };

  return (
    <section className="login-page-wrap" id="login-in-page">
      <style>{`
        #login-in-page * {
          font-family: 'Roboto', sans-serif;
        }

        .bg-image-grid {
          position: fixed;
          inset: 0;
          display: grid;
          grid-template-columns: repeat(${gridDims.cols}, 1fr);
          grid-auto-rows: ${window.innerWidth <= MOBILE_BREAKPOINT ? CELL_SIZE_MOBILE : CELL_SIZE_DESKTOP}px;
          grid-auto-flow: dense;
          gap: 3px;
          overflow: hidden;
          z-index: 0;
        }

        .bg-image-grid img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0.9;
        }

        .bg-image-grid .tile-wide {
          grid-column: span 2;
        }

        .bg-image-grid .tile-tall {
          grid-row: span 2;
      }
          
        #login-in-page {
          width: 100%;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          position: relative;
          background: rgba(0, 0, 0, 0.55);
        }

        /* Full-bleed background image, same asset as before */
        .login-bg-image {
          position: fixed;
          inset: 0;
          z-index: 0;
        }

        .login-bg-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0.18;
        }

        #login-in-page::before {
          content: "";
          position: fixed;
          inset: 0;
          background: rgba(199, 104, 6, 0.55);
          z-index: 1;
          pointer-events: none;
        }

        .login-form-col {
          position: relative;
          z-index: 2;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .login-box {
          width: 100%;
          max-width: 420px;
          text-align: center;
          background: rgba(255, 255, 255, 0.92);
          border-radius: 16px;
          padding: 32px 28px;
          box-shadow: 0 20px 48px rgba(0, 0, 0, 0.25);
        }

        .login-box .logo-wrap {
          margin: 0 auto 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .login-box .logo-wrap img {
          max-width: 220px;
          width: 100%;
          object-fit: contain;
        }

        .login-box h2 {
          color: #16a34a;
          font-weight: 700;
          font-size: clamp(20px, 4vw, 24px);
          margin-bottom: 4px;
        }

        .login-box .subtitle {
          color: #6b7280;
          font-size: 13px;
          margin-bottom: 24px;
        }

        .login-field {
          text-align: left;
          margin-bottom: 16px;
        }

        .login-field label {
          display: block;
          color: #374151;
          font-weight: 600;
          font-size: 12.5px;
          margin-bottom: 6px;
        }

        .login-input-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f5f7f6;
          border: 1.5px solid #e2e5e4;
          border-radius: 10px;
          padding: 0 12px;
          height: 44px;
          transition: border-color 0.2s ease, background 0.2s ease;
        }

        .login-input-wrap:focus-within {
          border-color: #16a34a;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(199, 104, 6, 0.15);
        }

        .login-input-wrap .field-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #16a34a;
        }

        .login-input-wrap input {
          flex: 1;
          min-width: 0;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          color: #111827;
          font-size: 14px;
          padding: 0;
        }

        .login-input-wrap input::placeholder {
          color: #9ca3af;
        }

        .login-input-wrap .toggle-eye {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          cursor: pointer;
          color: #6b7280;
        }

        .login-input-wrap .toggle-eye:hover {
          color: #16a34a;
        }

        /* Program Code custom dropdown */
        .login-dropdown {
          position: relative;
        }

        .login-dropdown-trigger {
          width: 100%;
          height: 44px;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f5f7f6;
          border: 1.5px solid #e2e5e4;
          border-radius: 10px;
          padding: 0 12px;
          cursor: pointer;
          transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
        }

        .login-dropdown-trigger:hover {
          background: #eef1f0;
        }

        .login-dropdown-trigger.open {
          border-color: #16a34a;
          background: #ffffff;
          box-shadow: 0 4px 14px rgba(22, 163, 74, 0.15);
        }

        .login-dropdown-trigger .field-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #16a34a;
        }

        .login-dropdown-value {
          flex: 1;
          min-width: 0;
          text-align: left;
          font-size: 14px;
          font-weight: 500;
          color: #111827;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .login-dropdown-value.placeholder {
          color: #9ca3af;
          font-weight: 400;
        }

        .login-dropdown-caret {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #6b7280;
          font-size: 13px;
          transition: transform 0.25s ease, color 0.2s ease;
        }

        .login-dropdown-trigger.open .login-dropdown-caret {
          transform: rotate(180deg);
          color: #16a34a;
        }

        .login-dropdown-menu {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          background: #ffffff;
          border: 1.5px solid #e2e5e4;
          border-radius: 10px;
          box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
          list-style: none;
          margin: 0;
          padding: 6px;
          max-height: 220px;
          overflow-y: auto;
          z-index: 20;
          animation: dropdownFadeIn 0.15s ease;
        }

        @keyframes dropdownFadeIn {
          from {
            opacity: 0;
            transform: translateY(-4px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .login-dropdown-option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          padding: 9px 10px;
          border-radius: 8px;
          font-size: 13.5px;
          color: #374151;
          cursor: pointer;
          transition: background 0.15s ease, color 0.15s ease;
        }

        .login-dropdown-option:hover {
          background: #f0fdf4;
          color: #16a34a;
        }

        .login-dropdown-option.selected {
          background: #f0fdf4;
          color: #16a34a;
          font-weight: 600;
        }

        .login-dropdown-option-text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .forgot-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 18px;
        }

        .forgot-row a {
          color: #16a34a;
          font-size: 12.5px;
          font-weight: 600;
          text-decoration: none;
        }

        .forgot-row a:hover {
          text-decoration: underline;
        }

        .login-signin-btn {
          width: 100%;
          border: none;
          border-radius: 10px;
          padding: 12px;
          background: #16a34a;
          color: #fff;
          font-weight: 700;
          font-size: 13.5px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background 0.2s ease, transform 0.15s ease;
        }

        .login-signin-btn:hover {
          background: #a85705;
        }

        .login-signin-btn:active {
          transform: scale(0.98);
        }

        .login-signin-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        @media (max-width: 480px) {
          .login-box {
            max-width: 100%;
            padding: 26px 18px;
            border-radius: 14px;
          }
        }
      `}</style>

      {/* Background image - same asset path as before */}
      {/* <div className="login-bg-image">
        <img src={signup} alt="" />
      </div> */}

      <div className="bg-image-grid">
        {tiles.map((tile, idx) => (
          <img
            key={idx}
            src={tile.src}
            alt=""
            className={
              tile.span === 1 ? "tile-wide" : tile.span === 2 ? "tile-tall" : ""
            }
          />
        ))}
      </div>
      {/* Sign-in card, centered on page */}
      <div className="login-form-col">
        <div className="login-box">
          <div className="logo-wrap">
            <img src={logo} alt="IHFC Logo" />
          </div>

          <h2>Sign In</h2>
          <p className="subtitle">Please enter your details to sign in</p>

          <form onSubmit={handleLogin}>
            {/* Email */}
            <div className="login-field">
              <label>Email Address</label>
              <div className="login-input-wrap">
                <span className="field-icon">
                  <i className="ti ti-mail" />
                </span>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  onChange={getInputData}
                  required
                />
              </div>
            </div>

            {/* Password */}
            <div className="login-field">
              <label>Password</label>
              <div className="login-input-wrap">
                <span className="field-icon">
                  <i className="ti ti-lock" />
                </span>
                <input
                  type={passwordVisibility.password ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  onChange={getInputData}
                  required
                />
                <span
                  className="toggle-eye"
                  onClick={() => togglePasswordVisibility("password")}
                >
                  <i
                    className={`ti ${
                      passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                    }`}
                  />
                </span>
              </div>
            </div>

            {/* Program Code (custom dropdown) */}
            <div className="login-field">
              <label className="login-label" htmlFor="login-program">
                Program
              </label>
              <div className="login-dropdown" ref={programRef}>
                <button
                  type="button"
                  id="login-program"
                  className={`login-dropdown-trigger ${programOpen ? "open" : ""}`}
                  onClick={() => getCohortData()}
                  aria-haspopup="listbox"
                  aria-expanded={programOpen}
                >
                  <span className="field-icon">
                    <i className="ti ti-school" />
                  </span>
                  <span className={`login-dropdown-value`}>
                    {loading
                      ? "Loading..."
                      : selectedProgram
                        ? `${selectedProgram?.name} (${selectedProgram?.school_code})`
                        : "Select Program Code"}
                  </span>
                  <span className="login-dropdown-caret">
                    <i className="ti ti-chevron-down" />
                  </span>
                </button>

                {programOpen && (
                  <ul className="login-dropdown-menu" role="listbox">
                    {programCodes.map((p: any) => (
                      <li
                        key={p.code}
                        role="option"
                        aria-selected={
                          selectedProgram?.school_code === p.school_code
                        }
                        className={`login-dropdown-option ${selectedProgram?.code === p.school_code ? "selected" : ""}`}
                        onClick={() => {
                          setSelectedProgram(p);
                          setLoginData({
                            ...loginData,
                            program_code: p.school_code,
                          });
                          setProgramOpen(false);
                          localStorage.setItem(
                            "school_code",
                            JSON.stringify(p),
                          );
                        }}
                      >
                        <span className="login-dropdown-option-text">
                          {p.name} ({p.school_code})
                        </span>
                        {selectedProgram?.school_code === p.school_code && (
                          <i className="ti ti-check" />
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* Forgot password */}
            <div className="forgot-row">
              <Link to={routes.forgotPassword}>Forgot Password?</Link>
            </div>

            <button
              type="submit"
              className="login-signin-btn"
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                  style={{ width: "16px", height: "16px" }}
                ></div>
              )}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
